<template>
  <md-card class="md-layout-item md-size-100" v-if="landingPage">
    <md-card-header>
      <div class="md-layout md-alignment-center-left">
      <h1 v-if="landingPage.title" class="md-layout-item md-size-70">{{landingPage.title}}</h1>
      <div class="md-layout-item md-size-30 md-xsmall-size-70 md-alignment-center-center" v-if="landingPage.logo && landingPage.logo.length">
        <img :src="landingPage.logo[0]" />
      </div>
      <span class="h2 md-layout-item" v-if="landingPage.subtitle">{{landingPage.subtitle}}</span>
      </div>
    </md-card-header>
    <md-card-content>

      <div class="md-layout" v-if="landingPage.images && landingPage.images.length">
        <div class="md-layout-item md-medium-size-100 md-size-30" v-if="landingPage.images.length == 1">
          <img :src="landingPage.images[0]">
        </div>
        <div class="md-layout-item md-medium-size-100 md-size-30" v-else>
          <vueper-slides :slide-ratio="1 / 2">
            <template #arrow-left>
              <i class='far fa-chevron-left' />
            </template>

            <template #arrow-right>
              <i class='far fa-chevron-right'/>
            </template>
            <vueper-slide
              v-for="(src, i) in landingPage.images"
              :key="i"
              :image="src">
              <template #content>
                &nbsp;
              </template>
            </vueper-slide>
          </vueper-slides>
        </div>
        <div class="md-layout-item md-size-auto" v-if="landingPage.description" v-html="landingPage.description"/>
      </div>
      <div v-else v-html="landingPage.description">
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  props: ["landingPage"],
}
</script>